import { Progress as AntProgress, Flex } from "antd";
import { useTheme } from "styled-components";
import React from "react";
import Text from "../text";

const Progress = ({ percent, ...props }) => {
  const theme = useTheme();

  return (
    <Flex gap={"1rem"} align="center" {...props}>
      <AntProgress
        percent={percent}
        showInfo={false}
        strokeColor={theme.token.colorPrimary}
      />
      <Text
        weight={"600"}
        type="secondary"
        style={{ whiteSpace: "nowrap" }}
        children={`${Math.floor(percent)}%`}
      />
    </Flex>
  );
};

export default Progress;
